<template>
  <b-row>
    <el-dialog
      title="دیدگاه"
      v-if="commentsingle"
      :visible.sync="commentsingle"
      :before-close="handleClosecommentsingle"
      width="80%"
    >
      <Comments :articleid="articleidsingle" :article_name_row="false" />
    </el-dialog>
    
    <el-dialog
      title="ویرایش مطلب"
      v-if="editarticle"
      :visible.sync="editarticle"
      :before-close="handleCloseeditarticle"
      width="90%"
           style="direction: rtl"
    >
      <ArticleEdit :tabname="false" :articleid="articleidsingle" />
    </el-dialog>
    <el-dialog
      title="پاسخ دیدگاه"
      :visible.sync="dialogVisible"
      width="50%"
      style="direction: ltr"
      :before-close="handleClose"
    >
      <div style="direction: rtl">
        <a
          v-if="commentreply.commentable.type == 'article'"
          :href="`https://sonnat.net/${commentreply.commentable.id}`"
          target="_blank"
        >
          <span>{{ commentreply.commentable.title }}</span>
          <small class="mx-2 label label-sm label-info label-inline"
            >مقالات</small
          >
        </a>
        <a
          v-else-if="commentreply.commentable.type == 'video'"
          :href="`https://sonnat.net/video/${commentreply.commentable.id}`"
          target="_blank"
          ><span>{{ commentreply.commentable.title }}</span>
          <small class="mx-2 label label-sm label-danger label-inline"
            >ویدئو</small
          >
        </a>
        <div class="bg-gray p-4 my-4">{{ filterclean(commentreply.text) }}</div>
        <div
          class="bg-gray p-4 my-4"
          v-for="(item, index) in commentreply.replies"
          v-bind:key="index"
        >
          <span>{{ item.name }} : </span>
          {{ item.text }}
        </div>
        <Rtextarea label="پاسخ دیدگاه" v-model="adminreply.text" />

        <span slot="footer" class="dialog-footer">
          <div class="d-flex justify-content-end">
            <button class="btn btn-clean" @click="dialogVisible = false">
              بستن
            </button>
            <button class="btn btn-primary" @click="sendreply">ارسال</button>
          </div>
        </span>
      </div>
    </el-dialog>
    <b-col md="12">
      <b-card title="مدیریت دیدگاه ها">
        <b-col cols="3" class="left mb-3">
          <label>وضعیت نمایش دیدگاه ها</label>
          <select
            class="form-control"
            v-model="status"
            @change="initlizecomments"
          >
            <option value="pending">در انتظار تایید</option>
            <option value="approve">تایید شده</option>
            <option value="unapprove">تایید نشده</option>
            <option value="all">همه دیدگاه ها</option>
          </select>
        </b-col>
        <b-col cols="2" class="left mb-3 pt-4">
          <el-checkbox
            class="mt-4"
            v-model="filter"
            label="فیلتر کلمات"
            @change="changefilter"
            border
          ></el-checkbox>
        </b-col>
        <el-table
          class="table"
          :data="comments"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column
            width="80"
            align="center"
            prop="id"
            label="#"
            sortable
          >
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            label="نام ارسال کننده"
            sortable
          >
            <template slot-scope="scope">
              <div>
                <b class="text-danger w-100">{{
                  filterclean(scope.row.name)
                }}</b>
              </div>

              <small> <i class="el-icon-time"></i> {{ scope.row.date }}</small>
              <div>
                <small
                  v-if="scope.row.status == '-1'"
                  class="label label-sm label-danger label-inline"
                  >تایید نشده</small
                >
                <small
                  v-else-if="scope.row.status == 0"
                  class="label label-sm label-warning label-inline"
                  >درانتظار تایید</small
                >
                <small
                  v-else-if="scope.row.status == 1"
                  class="label label-sm label-success label-inline"
                  >تایید شده</small
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column
            class-name="warptext"
            align="center"
            label="متن دیدگاه"
            sortable
          >
            <template slot-scope="scope">
              {{ filterclean(scope.row.text) }}
            </template>
          </el-table-column>

          <el-table-column
          v-if="article_name_row"
            class-name="warptext"
            align="center"
            label="نام مطلب"
            width="200"
            sortable
          >
            <template slot-scope="scope">
              <a
                v-if="scope.row.commentable.type == 'article'"
                :href="`https://sonnat.net/${scope.row.commentable.id}`"
                target="_blank"
              >
                <div class="font-small">{{ scope.row.commentable.title }}</div>
                <div class="label label-sm label-info label-inline">مقالات</div>
              </a>
              <a
                v-else-if="scope.row.commentable.type == 'video'"
                :href="`https://sonnat.net/video/${scope.row.commentable.id}`"
                target="_blank"
                ><div class="font-small">{{ scope.row.commentable.title }}</div>
                <div class="label label-sm label-danger label-inline">
                  ویدئو
                </div>
              </a>

              <button
                class="d-inline-block btn btn-sm btn-clean btn-icon"
                v-tooltip="{ content: 'نمایش همه دیدگاه های این مطلب' }"
              >
                <span
                  class="svg-icon svg-icon-md"
                  @click="showcomments(scope.row.commentable.id)"
                >
                  <i class="la la-comments"></i>
                </span>
              </button>
            </template>
          </el-table-column>
 
          <el-table-column align="center" width="120">
            <template slot-scope="scope">
             

                <button
                v-if="scope.row.commentable.type == 'article'"
                @click="editarticledidialog(scope.row.commentable.id)"
                class="btn btn-sm btn-clean btn-icon"
                v-tooltip="{ content: 'ویرایش مطلب' }"
              >
                <span class="svg-icon svg-icon-md">
                  <i class="la la-edit"></i>
                </span>
              </button>
              <router-link
                v-else-if="scope.row.commentable.type == 'video'"
                :to="`/video/edit/${scope.row.commentable.id}`"
                class="btn btn-sm btn-clean btn-icon"
                v-tooltip="{ content: 'ویرایش ویدئو' }"
              >
                <span class="svg-icon svg-icon-md">
                  <i class="la la-edit"></i>
                </span>
              </router-link>

              <button
                @click="reply(scope.row)"
                class="btn btn-sm btn-clean btn-icon"
                v-tooltip="{ content: 'پاسخ دیدگاه' }"
              >
                <span class="svg-icon svg-icon-md">
                  <i class="la la-reply text-info font-bold"></i>
                </span>
              </button>
              <button
                @click="approve(scope.row.id)"
                class="btn btn-sm btn-clean btn-icon"
                v-tooltip="{ content: 'تایید دیدگاه' }"
              >
                <span class="svg-icon svg-icon-md">
                  <i class="la la-check text-success font-bold"></i>
                </span>
              </button>
              <button
                @click="unapprove(scope.row.id)"
                class="btn btn-sm btn-clean btn-icon"
                v-tooltip="{ content: 'عدم تایید دیدگاه' }"
              >
                <span class="svg-icon svg-icon-md">
                  <i class="la la-close text-danger font-bold"></i>
                </span>
              </button>
              <button
                @click="remove(scope.row.id)"
                class="btn btn-sm btn-clean btn-icon"
                v-tooltip="{ content: 'حذف دیدگاه' }"
              >
                <span class="svg-icon svg-icon-md">
                  <i class="la la-trash"></i>
                </span>
              </button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager, next"
          :total="meta.total"
          :page-size="15"
          :page-count="meta.per_page"
          :current-page="meta.current_page"
          @current-change="changepage"
        >
        </el-pagination>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import ApiService from "@/core/services/api.service";
// const filter = new Filter({ replaceRegex: /[A-Za-z0-9_]/g });

export default {
  name: "Comments",
  props: {
    articleid: {
      default: "all",
    },
    article_name_row: {
      default: true,
    },
  },
  data() {
    return {
      comments: [],
      links: [],
      meta: [],
      search: "",
      dialogVisible: false,
      editarticle: false,
      commentsingle: false,
      filter: true,
      status: "pending",
      page: 0,
      articleidsingle: "all",
      commentreply: {
        commentable: {
          id: "",
          type: "",
          title: "",
        },
        text: "",
      },
      adminreply: {
        text: "",
      },
    };
  },
  mounted() {
    this.initlizecomments();
  },
  methods: {
    initlizecomments() {
      if (this.articleid == "all") {
        this.getall();
      } else {
        this.getcomments();
      }
    },
    getall: function () {
      ApiService.query("admin/comment#", {
        params: {
          status: this.status,
          page: this.page,
        },
      })
        .then(({ data }) => {
          this.comments = data.data;
          this.links = data.links;
          this.meta = data.meta;
        })
        .catch(({ response }) => {});
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClosecommentsingle() {
      this.commentsingle = false;
    },
    handleCloseeditarticle() {
      this.editarticle = false;
    },
    getcomments() {
      ApiService.query("admin/getcomments", {
        params: {
          status: this.status,
          page: this.page,
          articleid: this.articleid,
        },
      })
        .then(({ data }) => {
          this.comments = data.data;
          this.links = data.links;
          this.meta = data.meta;
        })
        .catch(({ response }) => {});
    },
    reply(comment) {
      this.dialogVisible = true;
      this.commentreply = comment;
    },
    remove: function (id) {
      ApiService.delete("admin/comment/" + id)
        .then(({ data }) => {
          this.changepage(this.page);

          this.$vs.notification({
            progress: "auto",
            color: "danger",
            position: "bottom-center",
            text: "دیدگاه با موفقیت حذف شد",
          });
        })
        .catch(({ response }) => {});
    },
    sendreply: function () {
      ApiService.post("admin/comment/reply", {
        id: this.commentreply.id,
        comment: this.adminreply,
      })
        .then(({ data }) => {
          this.changepage(this.page);
          this.adminreply.text = "";
          this.dialogVisible = false;
          this.$vs.notification({
            progress: "auto",
            color: "success",
            position: "bottom-center",
            text: "دیدگاه با موفقیت ارسال شد",
          });
        })
        .catch(({ response }) => {});
    },
    approve: function (id) {
      ApiService.post("admin/comment/changestatus", {
        id: id,
        type: "approve",
      })
        .then(({ data }) => {
          this.changepage(this.page);
          this.$vs.notification({
            progress: "auto",
            color: "success",
            position: "bottom-center",
            text: "دیدگاه با موفقیت تغییر وضعیت یافت",
          });
        })
        .catch(({ response }) => {});
    },
    unapprove: function (id) {
      ApiService.post("admin/comment/changestatus", {
        id: id,
        type: "unapprove",
      })
        .then(({ data }) => {
          this.changepage(this.page);
          this.$vs.notification({
            progress: "auto",
            color: "success",
            position: "bottom-center",
            text: "دیدگاه با موفقیت تغییر وضعیت یافت",
          });
        })
        .catch(({ response }) => {});
    },
    changefilter() {
      let comments = this.comments;
      this.comments = comments;
    },
    showcomments(id) {
      this.articleidsingle = id;
      this.commentsingle = true;
    },
    editarticledidialog(id) {
      this.articleidsingle = id;
      this.editarticle = true;
    },
    filterclean(text) {
      let filtertext = text;
      if (this.filter && filtertext != null) {
        var banned = [
          "جق",
          "کوس",
          "کون",
          "صیغه",
          "کس",
          "لامذهب",
          "سگ",
          "زنا",
          "سکس",
          "سکسی",
          "کیر",
          "پدر",
          "مادر",
          "مادرتو",
          "مادرت",
          "پدرتو",
          "پدرت",
          "گاییدت",
          "حرام زاده",
          "حرامزاده",
          "ملعون",
          "لعنت",
          "بی بته",
          "گاییدم",
          "گایید",
        ];
        for (var i = 0; i < banned.length; i++) {
          if (filtertext.includes(banned[i])) {
            filtertext = filtertext.replace(
              banned[i],
              "*".repeat(banned[i].length)
            ); //sets the input to * times the length of the banned word
          }
        }
      }
      return filtertext;
    },
    changepage: function (page) {
      let thisv = this;
      this.page = page;
      this.initlizecomments();
    },
  },
};
</script>
<style>
.color-red {
  color: brown;
}
</style>
